module.exports = "/_next/static/images/wreath_global_startup_v2_220w-e6aa126f0d57c876c90f157abf8983c3.webp";